// @flow

import {
  GetSettings,
  GetSettingsSuccess,
  GetSettingsError,
  ClearSettings,
} from "@modules/settings/constants/actions";
import rules from "../rules";
import type { Settings, SchemaFilterRules } from "@modules/settings/types";
import { cloneObject } from "@utils/object";

export type SchemaState = $Exact<{
  settings: Settings | null,
  rules: SchemaFilterRules,
  error: ?string,
}>;

export const initialState: SchemaState = {
  settings: null,
  rules,
  error: null,
};

export const onClearSettings = (state: SchemaState) => ({ payload }: Object) => {
  return {
    ...state,
    settings: null,
  };
};

export const onGetSettings = (state: SchemaState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
  };
};

export const onGetSettingsSuccess = (state: SchemaState) => ({ payload }: Object) => {
  return { ...state, error: null, settings: payload };
};

export const onGetSettingsError = (state: SchemaState) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
  };
};

export default (state: SchemaState = initialState, action: *): SchemaState => {
  const act = {
    [ClearSettings]: onClearSettings,
    [GetSettings]: onGetSettings,
    [GetSettingsSuccess]: onGetSettingsSuccess,
    [GetSettingsError]: onGetSettingsError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
